import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {AppConfigInfo} from '@models/app-config.model';
import {HttpClient} from '@angular/common/http';
import config from '@config/config.json';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient
  ) {
  }

  setCompleteUrl(requestUrl: string): string {
    return environment.apiUrl + requestUrl;
  }

  async getAppConfigInfo(): Promise<AppConfigInfo> {
    const url = '/api/v1/appinfo';
    return this.http.get<AppConfigInfo>(url).toPromise();
  }

  getFrontVersion(): string {
    return config.version;
  }
}
